import React from "react"; // Required for JSX even if not explicitly used
import { UserTierBadge } from "@/components/UserTierBadge";
import { Link } from "react-router-dom";

export default function TopHeader() {
    return (
        <div className="jr-shell-header">
            <header className="relative flex min-h-20 items-center justify-end px-4 py-4 text-[var(--jr-text)]">
                <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center gap-3">
                    <span className="jr-brand-mark" aria-hidden="true">
                        <span className="jr-brand-mark-core" />
                    </span>
                    <h1 className="jr-display text-[2rem] font-semibold leading-none tracking-[0.12em] lowercase text-[var(--jr-text)]">joyride</h1>
                    <UserTierBadge className="ml-1 self-center" />
                </div>
                <Link to="/auth" />
            </header>
        </div>
    );
}
